import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useFieldArray } from 'react-hook-form';
import { useTranslate } from 'shared/helper/translate';
import ServiceOptionSelector from './ServiceOptionSelector';
import OrderServicesWrapper from './OrderServicesWrapper';
import OrderService from './OrderService';
var OrderServicesFieldset = function OrderServicesFieldset(_ref) {
  var methods = _ref.methods,
    orderServices = _ref.orderServices,
    isRemovable = _ref.removable,
    onAddCallback = _ref.onAdd,
    onRemoveCallback = _ref.onRemove,
    serviceOptions = _ref.serviceOptions,
    editingOrderDetails = _ref.editingOrderDetails;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useFieldArray = useFieldArray({
      control: methods.control,
      name: 'services'
    }),
    services = _useFieldArray.fields,
    addService = _useFieldArray.append,
    removeService = _useFieldArray.remove;
  var displayedServices = editingOrderDetails ? services : orderServices;
  var removable = isRemovable && services.length > 1;
  var onAdd = function onAdd(service) {
    addService(service);
    onAddCallback(service);
  };
  var onRemove = function onRemove(service, i) {
    removeService(i);
    onRemoveCallback(service);
  };
  if (displayedServices.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement(OrderServicesWrapper, null, displayedServices.map(function (service, i) {
    return /*#__PURE__*/React.createElement(OrderService, {
      key: service.id || service.key,
      service: service,
      actions: function actions() {
        return removable && service.canBeRemovedFromOrder ? /*#__PURE__*/React.createElement("button", {
          "aria-label": t('remove'),
          type: "button",
          className: "float-end bg-transparent btn-link text-danger",
          onClick: function onClick() {
            return onRemove(service, i);
          }
        }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
          icon: "fa-solid fa-circle-xmark"
        })) : null;
      }
    });
  }), editingOrderDetails && serviceOptions ? /*#__PURE__*/React.createElement(ServiceOptionSelector, {
    addServiceOption: onAdd,
    serviceOptions: serviceOptions.filter(function (serviceOption) {
      return !services.find(function (_ref2) {
        var serviceIdentity = _ref2.serviceIdentity;
        return serviceIdentity === serviceOption.serviceIdentity;
      });
    })
  }) : null);
};
export default OrderServicesFieldset;